/*
  Open the cart drawer when something is added to the cart.

  Concept does this itself, at the end of ProductForm's submit handler:

      document.dispatchEvent(new CustomEvent('ajaxProduct:added', ...));
      this.cartDrawer?.show(this.activeElement);

  On a product page that runs and the drawer opens. On a collection or home
  page it does not: the card's form is Concept's own `product-form`, the
  handler reaches the end (the `cartDrawer` getter is read and `ajaxProduct:added`
  fires — both measured), and the drawer still never takes its `open`
  attribute. Measured on /collections/all with the storefront's own cards: the
  line is added every time, the drawer opens none of them.

  So the drawer is opened from the event instead, which every add path in this
  theme dispatches — the card form, the product page, quick view — and which is
  what the header panel this drawer replaced listened to for the same reason.
  `show()` returns early when the drawer is already open, so the product page
  firing both paths costs nothing.

  Loaded by sections/cart-drawer.liquid, so it is absent on /cart and wherever
  the cart type is not 'drawer' — the two cases with no drawer to open.
*/
(() => {
  const open = () => {
    const drawer = document.getElementById('CartDrawer');
    // `show` arrives with the custom element definition in cart.js, which is
    // also deferred; on the rare add that beats it, the theme has simply not
    // upgraded the element yet and there is nothing to open.
    if (typeof drawer?.show === 'function') drawer.show();
  };

  document.addEventListener('ajaxProduct:added', open);
})();
